import { headerHeightVar } from '../__utils/vhUnit';

const alertBar = document.querySelector('#header-alert-bar');
const header = document.querySelector('header.main-header');
const closeTrigger = document.querySelector(
    '#header-alert-bar .header-alert-bar__close'
);
const { body } = document;
let alertBarPresence = alertBar ? true : false;

const closeBar = () => {
    sessionStorage.setItem('jmf-alert-bar', true);
    removeBar();
    headerHeightVar();
};

const bindEvents = () => {
    closeTrigger.addEventListener('click', closeBar);
};

const showBar = () => {
    alertBar.removeAttribute('style');
    if (header.classList.contains('main-header--fixed')) {
        body.style.marginTop = `${alertBar.getBoundingClientRect().height}px`;
    }
};

const removeBar = () => {
    alertBar.remove();
    if (header.classList.contains('main-header--fixed')) {
        body.style.marginTop = 0;
        alertBarPresence = false;
    }
};

const checkStatus = () => {
    if (sessionStorage.getItem('jmf-alert-bar')) {
        removeBar();
    } else {
        showBar();
        bindEvents();
    }
};

const init = () => {
    if (alertBar) {
        checkStatus();
    }
};

export const alertBarResize = () => {
    if (alertBarPresence && header.classList.contains('main-header--fixed')) {
        body.style.marginTop = `${alertBar.getBoundingClientRect().height}px`;
    }
};

export default init;
